// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.messageCon[data-v-100a344e] {\n  background: #eee;\n}\n.messageCon pre[data-v-100a344e] {\n  max-height: calc(100vh - 280px);\n  overflow-y: auto;\n  white-space: break-spaces;\n  margin: 0;\n  padding: 0 10px;\n  line-height: 26px;\n}\n", ""]);
// Exports
module.exports = exports;
